<template>
  <!-- 设备配置页面 -->
  <Row class="deviceConfig no-cancel-tree">
    <!-- 左侧的区域信息 -->
    <i-col span="9" class="left-box">
      <h3>{{ $t("deviceSip.area") }}</h3>
      <config-tree
        ref="configTree"
        :key="timeStamp"
        :current-step="currentStep"
        :current-chosen-node="currentNode['$treeNodeId']"
        @selectTree="selectTree"
      ></config-tree>
    </i-col>
    <!-- 右侧的功能选项 -->
    <i-col span="14" class="right-box forbit-cancel-tree">
      <div class="fun-box">
        <Button
          class="pro-edit-color forbit-cancel-tree"
          icon="md-checkbox-outline"
          size="large"
          @click="showAddAreaDeviceModal(false, 1)"
        >
          {{ $t("deviceSip.editDevice") }}
        </Button>
        <Button
          class="pro-add-color forbit-cancel-tree"
          icon="md-add-circle"
          size="large"
          @click="showAddAreaDeviceModal(false, 0)"
        >
          {{ $t("deviceSip.addDevice") }}
        </Button>
        <Button
          class="pro-batch-color forbit-cancel-tree"
          icon="md-albums"
          size="large"
          @click="showAddAreaDeviceModal(true, 0)"
        >
          {{ $t("deviceSip.batchDevice") }}
        </Button>
        <Button
          icon="ios-trash"
          class="pro-del-color forbit-cancel-tree"
          size="large"
          @click="showDelDeviceModal"
        >
          {{ $t("deviceSip.delDevice") }}
        </Button>
      </div>
      <!-- 选中的设备详情 -->
      <device-msg :key="timeStamp" :current-node="currentNode"></device-msg>
    </i-col>
    <!-- 底部按钮 底部居中垂直 -->
    <i-col span="24" class="footer-btn forbit-cancel-tree">
      <Button type="primary" ghost size="large" @click="setCurrentStep">
        {{ $t("deviceSip.prev") }}
      </Button>
      <Button type="primary" size="large" @click="checkFileStream">
        {{ $t("deviceSip.exportAddr") }}
      </Button>
    </i-col>
    <!-- 新增设备modal 单个 -->
    <add-device-modal
      ref="addDeviceModal"
      :is-batch-device="isBatchDevice"
      :device-type="deviceType"
      :current-node="currentNode"
      @updateTree="updateTree"
      @updateMsg="updateMsg"
    ></add-device-modal>
    <!-- 新增设备modal 批量 -->
    <add-batch-device-modal
      ref="addBatchDeviceModal"
      :current-node="currentNode"
      :area-type-name-list="areaTypeNameList"
      @updateTree="updateTree"
    ></add-batch-device-modal>
    <!-- 删除弹窗 -->
    <confirmModal ref="confirmModal" @afterComfirm="delDevice">
      <div slot="info">
        <p class="p-text">
          {{ $t("deviceSip.deleteTip") }}“{{ currentNode.name }}”?
        </p>
      </div>
    </confirmModal>
    <!-- 提交确认弹窗 -->
    <modal ref="resultModal" :type="modalType" @afterComfirm="backBtn"></modal>
    <!-- 提交结果显示 -->
    <submit-error-modal ref="submitErrorModal" @updateTree="updateTree">
    </submit-error-modal>
    <!-- 导出地址簿：增加加密密码输入步骤 -->
    <export-modal ref="exportModal" @updateTree="updateTree"></export-modal>
  </Row>
</template>
<script>
import configTree from "./configTree";
import addDeviceModal from "./addDeviceModal";
import deviceMsg from "./deviceMsg";
import addBatchDeviceModal from "./addBatchDeviceModal";
import submitErrorModal from "./submitErrorModal";
import exportModal from "./exportModal";
import { mapState } from "vuex";

export default {
  name: "deviceConfig",
  components: {
    configTree,
    addDeviceModal,
    deviceMsg,
    addBatchDeviceModal,
    submitErrorModal,
    exportModal,
  },
  filters: {},
  directives: {},
  mixins: {},
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      modalType: false, // 操作modal
      timeStamp: new Date().getTime(),
      isBatchDevice: false,
      deviceType: "", // 0 新增设备；1是编辑设备
      currentNode: {
        isTopDevice: null,
        name: "",
        funList: [],
        netInfoDTO: {
          mode: 1,
          mask: "",
          gateway: "",
          ip: "",
          dns1: "",
          dns2: "",
        },
        sipInfoDTOList: [],
      }, // 当前选中的node节点
      areaNode: {}, // 选中的区域节点
      currentLevel: 0, // 当前区域层级  (范围1-5)
      delDeviceName: "",
    };
  },
  computed: {
    // 离线配置改动点11
    ...mapState("projectConfig", [
      "areaData",
      "areaDeviceData",
      "areaTypeNameList",
      "projectInfo",
    ]),
  },
  watch: {},
  created() {},
  mounted() {},
  beforeUpdate() {},
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    updateMsg(val) {
      this.currentNode = val;
      this.timeStamp = new Date().getTime();
    },
    // 更新树组件的渲染
    updateTree() {
      this.timeStamp = new Date().getTime();
    },
    // 选中过的树节点
    selectTree(key) {
      this.currentNode = key;
      if (key.groupList) {
        this.areaNode = key;
      }
    },
    // 展示添加设备modal
    // isBatchDevice: false  添加单个设备 ; true：批量添加设备
    // deviceType: 0  添加单个设备 ; 1:编辑单个设备
    showAddAreaDeviceModal(isBatchDevice, deviceType) {
      if (isBatchDevice) {
        if (this.areaDeviceData && this.areaDeviceData.length === 0) {
          // 没有区域信息，不能批量操作添加设备（因为需要选区域类型）
          this.$Message.error(this.$t("deviceSip.areaTip3"));
          return;
        } else {
          this.$refs.addBatchDeviceModal.dialogVisible = true;
          return;
        }
      } else {
        if (this.areaDeviceData && this.areaDeviceData.length === 0) {
          // 没有区域信息，不能编辑设备
          if (deviceType === 1) {
            this.$Message.error(this.$t("deviceSip.deviceTip1"));
            return;
          }
        } else {
          if (
            deviceType === 1 &&
            this.currentNode.funList &&
            this.currentNode.funList.length === 0
          ) {
            this.$Message.error(this.$t("deviceSip.deviceTip1"));
            return;
          }
          if (deviceType === 1 && !this.currentNode.funList) {
            this.$Message.error(this.$t("deviceSip.deviceTip1"));
            return;
          }
          if (
            deviceType === 0 &&
            this.currentNode.funList &&
            this.currentNode.funList.length > 0
          ) {
            this.$Message.error(this.$t("deviceSip.deviceTip2"));
            return;
          } else {
            //  this.currentNode.isTopDevice = true; // 外围设备列表增加设备
          }
        }
      }

      this.isBatchDevice = isBatchDevice;
      this.deviceType = deviceType; // 新增modal或编辑modal
      this.$refs.addDeviceModal.dialogVisible = true;
    },
    // 展示删除设备modal
    showDelDeviceModal() {
      if (Object.keys(this.currentNode).length === 0) {
        this.$Message.error(this.$t("deviceSip.deleteTip3"));
        return;
      }

      if (this.currentNode.code) {
        this.$Message.error(this.$t("deviceSip.deleteTip2"));
        return;
      }
      if (this.currentNode.funList && this.currentNode.funList.length === 0) {
        this.$Message.error(this.$t("deviceSip.deleteTip3"));
        return;
      }
      this.$refs.confirmModal.dialogVisible = true;
    },
    // 删除设备
    delDevice() {
      // 遍历删除设备
      this.setDeepArrData(
        this.areaDeviceData,
        this.currentNode["$treeNodeId"],
        "$treeNodeId",
        "groupList",
        "name"
      );
      this.areaDeviceData = this.formateArray(this.areaDeviceData);
      let outsideDevList = [];
      outsideDevList = this.areaDeviceData.filter(
        (item) => item.isTopDevice && item.groupList
      );
      if (outsideDevList.length > 0) {
        // 存在最外围设备组，删除最外围设备组的显示
        let addressDeviceList = outsideDevList[0].groupList;
        this.$store.commit(
          "projectConfig/SET_ADDRESSDEVICELIST",
          addressDeviceList
        );
      }
      // 初始设备节点
      this.currentNode = {
        isTopDevice: null,
        name: "",
        funList: [],
        netInfoDTO: {
          mode: 1,
          mask: "",
          gateway: "",
          ip: "",
          dns1: "",
          dns2: "",
        },
        sipInfoDTOList: [],
      };
      this.$store.commit(
        "projectConfig/SET_AREADEVICEDATA",
        this.areaDeviceData
      );

      // 更新树组件的渲染
      this.$emit("updateTree");
    },
    // 递归查找 tree 数据中的 id 的 名称; 可以传入 字段参数的名称 ，有默认值
    // 递归 遍历深层 数组 要有接收值 才可以
    setDeepArrData(
      arr,
      id,
      idStr = "$treeNodeId",
      child = "groupList",
      name = "name"
    ) {
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];
        if (item[idStr] === id) {
          // 遍历
          arr.splice(i, 1);
          this.$forceUpdate();

          // 操作成功，关闭弹窗
          this.$refs.resultModal.dialogVisible = true;
          this.modalType = true;
          return;
        }

        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepArrData(item[child], id, idStr, child, name);
        }
      }
    },
    // 格式化数据
    formateArray(array) {
      // 过滤外层设备组
      for (const item of array) {
        if (Array.isArray(item["groupList"])) {
          let currentDeviceList = item.groupList.filter((i) => {
            if (i.funList) {
              return i;
            }
          });

          item.devList = currentDeviceList;
        }

        if (Array.isArray(item["groupList"])) {
          this.formateArray(item["groupList"]);
        }
      }
      return array;
    },
    // 切换上下步骤
    setCurrentStep() {
      this.updateTree();
      // 离线配置改动点3
      this.$emit("setCurrentStep", this.currentStep - 1);
    },
    /**
     *checkFileStream:检查导出文件流是否有重复数据
     *有：显示重复数据弹窗
     *无：显示导出密钥弹窗
     */
    checkFileStream() {
      let _this = this;
      // 隐藏属性 $treeNodeId
      let submitArray = this.areaDeviceData;

      this.formateData(submitArray);
      this.formateLevel(submitArray);

      // 清除首层设备
      let addressDeviceList = submitArray.filter((item) => item.isTopDevice);
      if (addressDeviceList.length > 0) {
        addressDeviceList = addressDeviceList[0].devList;
      }
      submitArray = submitArray.map((item) => {
        if (!item.isTopDevice) {
          return item;
        } else {
          return "";
        }
      });
      submitArray = submitArray.filter((item) => item); // 过滤空值
      let params = {
        addressDeviceList: addressDeviceList,
        addressGroupList: submitArray,
        fileVersion: {
          version: this.fileVersion,
        },
        project: this.projectInfo,
      };
      console.log("保存参数");
      console.log(JSON.stringify(params));

      this.$store
        .dispatch("projectConfig/exportAddrBook", params)
        .then((response) => {
          const resData = response;
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            // 此处两种判断返回信息的方法可选其一
            // 方法一：
            try {
              const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
              // 后台信息
              console.log(jsonData);
              if (jsonData.result && jsonData.result.invalid === 0) {
                // 有重复项，显示重复项modal
                jsonData.result.deviceCheckResultList.map((item) => {
                  return Object.assign(item, {
                    isEdit: false,
                    baseIp: item.deviceIp,
                    baseName: item.deviceName,
                  });
                });
                _this.$refs.submitErrorModal.dataList =
                  jsonData.result.deviceCheckResultList;
                _this.$refs.submitErrorModal.dialogVisible = true;
              } else {
                _this.$refs.resultModal.dialogVisible = true;
                _this.modalType = true;
              }
            } catch (err) {
              // 解析成对象失败，说明是正常的文件流
              // 显示输入密钥弹窗
              _this.showExportModal();
            }
          };
          fileReader.readAsText(resData);
          this.updateTree();
        })
        .catch(() => {});
    },
    // 格式化提交数据
    formateData(a) {
      let _this = this;
      let submitData = a;
      submitData.forEach((item) => {
        // 设置树组件的唯一值
        item.treeNodeId = item.$treeNodeId;
        item.level = item.level ? item.level : _this.currentLevel;
        // 一层数据
        if (item.groupList) {
          // 设备
          item.devList = item.groupList.filter((i) => {
            if (i.funList) {
              return i;
            }
          });
          // 设置树组件的唯一值
          item.devList.forEach((devItem) => {
            devItem.treeNodeId = devItem.$treeNodeId;
          });
          // 区域
          item.groupList = item.groupList.filter((i) => {
            if (i.code) {
              return i;
            }
          });
          // 迭代
          if (Array.isArray(item.groupList) && item.groupList.length > 0) {
            _this.formateData(item.groupList);
          }
        }
      });
      submitData = JSON.parse(JSON.stringify(submitData));
      return submitData;
    },
    // 设置level的值
    formateLevel(a) {
      a.forEach((item) => {
        item.level = 1;
        if (item.groupList) {
          item.groupList.forEach((sitem) => {
            sitem.level = 2;

            if (sitem.groupList) {
              sitem.groupList.forEach((ssitem) => {
                ssitem.level = 3;

                if (ssitem.groupList) {
                  ssitem.groupList.forEach((sssitem) => {
                    sssitem.level = 4;

                    if (sssitem.groupList) {
                      sssitem.groupList.forEach((ssssitem) => {
                        ssssitem.level = 5;
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
    showExportModal() {
      this.$refs.exportModal.exportModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.deviceConfig {
  width: 100%;
  height: 100%;
  .left-box,
  .right-box {
    background: #fff;
    height: 90%;
  }
  .left-box {
    margin-right: 30px;
    overflow: auto;
    h3 {
      padding: 30px 0 20px 30px;
    }
  }
  .right-box {
    padding: 30px 50px;
  }
  .fun-box {
    padding-bottom: 30px;
    border-bottom: 1px solid #e2e2e2;
    & > button {
      margin-right: 20px;
      margin-top: 10px;
    }
  }
  .content-box {
    padding-top: 30px;
    h2,
    h4 {
      display: flex;
    }
    h2 {
      margin-bottom: 30px;
    }
    h4 {
      margin-bottom: 15px;
      p {
        margin-left: 30px;
      }
    }
  }
  .footer-btn {
    margin-top: 20px;
    text-align: center;

    button {
      padding: 0 30px;
      margin-right: 20px;
    }
  }
}
.deviceMessage {
  .msg-box {
    height: 400px;
    overflow: auto;
  }
  h4 {
    display: flex;
    margin-bottom: 15px;
    .title-box {
      display: block;
      width: 150px;
      margin-right: 20px;
      word-break: break-all;
    }
  }
}
</style>
